/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - Lobby card footer component
 */

import type { LobbyMetadata } from "@game/domain";
import type React from "react";
import { useState } from "react";

interface LobbyCardFooterProps {
  lobby: LobbyMetadata;
  isFirst: boolean;
  onJoin: (lobbyId: string) => boolean;
}

export const LobbyCardFooter: React.FC<LobbyCardFooterProps> = ({
  lobby,
  isFirst,
  onJoin,
}) => {
  const [isJoining, setIsJoining] = useState(false);

  const canJoin = isFirst;
  const isUrgent = isFirst && lobby.secondsUntilStart <= 5;

  const handleJoinClick = () => {
    if (canJoin && !isJoining) {
      setIsJoining(true);
      const success = onJoin(lobby.id);
      if (!success) {
        setIsJoining(false);
      }
    }
  };

  const buttonText = isJoining
    ? "JOINING..."
    : canJoin
      ? isUrgent
        ? "JOIN NOW!"
        : "JOIN →"
      : "IN QUEUE";

  const buttonClass = `lobby-card-join-btn ${canJoin ? "join-enabled" : "join-disabled"}`;

  return (
    <div className="lobby-card-footer">
      <button
        className={buttonClass}
        disabled={!canJoin || isJoining}
        onClick={handleJoinClick}
        type="button"
      >
        {buttonText}
      </button>
    </div>
  );
};
